<div class="text-slate-400 text-center">
  <h1 class="font-bold">Welcome to Prefund</h1>
  <p class="mb-4">
    <span class="block">Currently, you have no Entries.</span> To get started,
    you can either:
  </p>
  <ul>
    <li class="underline cursor-pointer" (click)="addEntry.emit()">
      Create an Entry
    </li>
    <li class="underline cursor-pointer" (click)="openPlanner.emit()">
      Start Planning
    </li>
  </ul>
</div>
